module.exports = __webpack_public_path__ + "static/img/Testimonial1-blue.272c016.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Testimonial1-blue.png
// module id = R3qm
// module chunks = 0